import { c as _c } from "react/compiler-runtime";
import { Phone } from "@mui/icons-material";
import { Button } from "@mui/material";
import classNames from "classnames";
import Image from "next/image";
const AppButton = t0 => {
  const $ = _c(56);
  let endIcon;
  let height;
  let iconSrc;
  let label;
  let onClick;
  let rest;
  let startIcon;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let width;
  if ($[0] !== t0) {
    ({
      label,
      onClick,
      disabled: t1,
      variant: t2,
      size: t3,
      startIcon,
      endIcon,
      iconSrc,
      iconWidth: t4,
      iconHeight: t5,
      width,
      height,
      className: t6,
      typographyClass: t7,
      sx: t8,
      style: t9,
      fullWidth: t10,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = endIcon;
    $[2] = height;
    $[3] = iconSrc;
    $[4] = label;
    $[5] = onClick;
    $[6] = rest;
    $[7] = startIcon;
    $[8] = t1;
    $[9] = t10;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
    $[18] = width;
  } else {
    endIcon = $[1];
    height = $[2];
    iconSrc = $[3];
    label = $[4];
    onClick = $[5];
    rest = $[6];
    startIcon = $[7];
    t1 = $[8];
    t10 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
    width = $[18];
  }
  const disabled = t1 === undefined ? false : t1;
  const variant = t2 === undefined ? "contained" : t2;
  const size = t3 === undefined ? "medium" : t3;
  const iconWidth = t4 === undefined ? 20 : t4;
  const iconHeight = t5 === undefined ? 20 : t5;
  const className = t6 === undefined ? "" : t6;
  const typographyClass = t7 === undefined ? "" : t7;
  let t11;
  if ($[19] !== t8) {
    t11 = t8 === undefined ? {} : t8;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const sx = t11;
  let t12;
  if ($[21] !== t9) {
    t12 = t9 === undefined ? {} : t9;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const style = t12;
  const fullWidth = t10 === undefined ? false : t10;
  let t13;
  if ($[23] !== iconHeight || $[24] !== iconSrc || $[25] !== iconWidth || $[26] !== startIcon) {
    t13 = () => {
      if (iconSrc) {
        return <Image src={iconSrc} alt="" width={iconWidth} height={iconHeight} style={{
          objectFit: "contain"
        }} />;
      }
      return startIcon;
    };
    $[23] = iconHeight;
    $[24] = iconSrc;
    $[25] = iconWidth;
    $[26] = startIcon;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const renderStartIcon = t13;
  let t14;
  if ($[28] !== width) {
    t14 = width && {
      width
    };
    $[28] = width;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== height) {
    t15 = height && {
      height
    };
    $[30] = height;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== fullWidth) {
    t16 = fullWidth && {
      width: "100%"
    };
    $[32] = fullWidth;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== sx || $[35] !== t14 || $[36] !== t15 || $[37] !== t16) {
    t17 = {
      textTransform: "none",
      boxShadow: "none",
      ...t14,
      ...t15,
      ...t16,
      ...sx
    };
    $[34] = sx;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  const buttonSx = t17;
  let t18;
  if ($[39] !== style) {
    t18 = {
      ...style
    };
    $[39] = style;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  const buttonStyle = t18;
  const t19 = `${typographyClass} ${className}`;
  let t20;
  if ($[41] !== renderStartIcon) {
    t20 = renderStartIcon();
    $[41] = renderStartIcon;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== buttonStyle || $[44] !== buttonSx || $[45] !== disabled || $[46] !== endIcon || $[47] !== fullWidth || $[48] !== label || $[49] !== onClick || $[50] !== rest || $[51] !== size || $[52] !== t19 || $[53] !== t20 || $[54] !== variant) {
    t21 = <Button variant={variant} size={size} onClick={onClick} disabled={disabled} className={t19} sx={buttonSx} style={buttonStyle} startIcon={t20} endIcon={endIcon} fullWidth={fullWidth} {...rest}>{label}</Button>;
    $[43] = buttonStyle;
    $[44] = buttonSx;
    $[45] = disabled;
    $[46] = endIcon;
    $[47] = fullWidth;
    $[48] = label;
    $[49] = onClick;
    $[50] = rest;
    $[51] = size;
    $[52] = t19;
    $[53] = t20;
    $[54] = variant;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  return t21;
};
const PrimaryButton = ({
  title,
  onClick,
  disabled = false,
  isClickable = false,
  color = "!bg-[--colorPrimaryPrimary]",
  buttonClassName,
  startIcon = <Phone className="!w-[18px]" />,
  ...rest
}) => {
  return <Button variant="contained" className={`!rounded-[100px] ${buttonClassName} ${color}`} onClick={onClick} disabled={disabled && !isClickable} {...rest} startIcon={startIcon}>
      {title}
    </Button>;
};
const SecondaryButton = t0 => {
  const $ = _c(18);
  let onClick;
  let rest;
  let t1;
  let t2;
  let t3;
  let title;
  if ($[0] !== t0) {
    ({
      title,
      onClick,
      disabled: t1,
      fullWidth: t2,
      className: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = onClick;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = title;
  } else {
    onClick = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    title = $[6];
  }
  const disabled = t1 === undefined ? false : t1;
  const fullWidth = t2 === undefined ? true : t2;
  const className = t3 === undefined ? "h-[40px] padding-x-24" : t3;
  const t4 = !disabled;
  let t5;
  if ($[7] !== disabled || $[8] !== t4) {
    t5 = classNames({
      "disabled-border": disabled,
      "secondary-border !text-[--textSecondarySecondary]": t4
    });
    $[7] = disabled;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const btnClassName = t5;
  let t6;
  if ($[10] !== fullWidth) {
    t6 = classNames({
      "w-full": fullWidth
    });
    $[10] = fullWidth;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const widthClassName = t6;
  const t7 = `${btnClassName} ${widthClassName} ${className} !bg-transparent !rounded-[100px] m3-label-large`;
  let t8;
  if ($[12] !== disabled || $[13] !== onClick || $[14] !== rest || $[15] !== t7 || $[16] !== title) {
    t8 = <Button variant="contained" className={t7} onClick={onClick} disabled={disabled} {...rest}>{title}</Button>;
    $[12] = disabled;
    $[13] = onClick;
    $[14] = rest;
    $[15] = t7;
    $[16] = title;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export { PrimaryButton, SecondaryButton, AppButton };